var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 13.4167C25.004 14.9565 24.6443 16.4756 23.95 17.85C23.1268 19.4971 21.8614 20.8824 20.2954 21.8509C18.7293 22.8193 16.9246 23.3327 15.0833 23.3334C13.5435 23.3374 12.0245 22.9776 10.65 22.2834L4 24.5L6.21667 17.85C5.52242 16.4756 5.16265 14.9565 5.16667 13.4167C5.16738 11.5754 5.68071 9.77069 6.64917 8.20468C7.61763 6.63866 9.00296 5.3732 10.65 4.55003C12.0245 3.85579 13.5435 3.49602 15.0833 3.50003H15.6667C18.0984 3.63419 20.3952 4.66059 22.1173 6.3827C23.8394 8.10482 24.8658 10.4016 25 12.8334V13.4167Z",
    stroke: "#008FBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/messageCircle.730af1726dbe4e2f5c7685412f74cc33.svg";
export { ForwardRef as ReactComponent };